import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { CheckoutConfirmationPageInitialData } from "./checkoutConfirmationPageInitialData";

export const checkoutConfirmationPageQueryOptions = (referenceCode: string) =>
  queryOptions({
    queryKey: pageDataKeys.page(`checkout/orderConfirmation/${referenceCode}`),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<CheckoutConfirmationPageInitialData>>(
        `/page-data/checkout/orderConfirmation/${referenceCode}`,
      ),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
